import React from "react";
import { normalizeSkillList } from "../../utils/skillUtils";

/**
 * Responsive skill badge list with deduplication and normalized casing.
 */
const SkillBadges = ({ skills, variant = "matched", emptyLabel = "Aucune compétence" }) => {
  const normalized = normalizeSkillList(skills);

  if (normalized.length === 0) {
    return <span className="skill-badges-empty">{emptyLabel}</span>;
  }

  return (
    <div className="skill-badges-container">
      {normalized.map((skill) => (
        <span key={skill} className={`skill-badge skill-badge--${variant}`}>
          {skill}
        </span>
      ))}
    </div>
  );
};

export default SkillBadges;
